import React from "react";
import "../../styles/components/marketplace-shared.css";

const MarketplaceListCard = ({
  className = "",
  code,
  title,
  headerBadges,
  metaItems = [],
  note,
  items = [],
  children,
  actions,
}) => (
  <article className={`marketplace-list-card ${className}`.trim()}>
    <div className="marketplace-list-card__top">
      <div>
        {code ? <span className="marketplace-list-card__code">{code}</span> : null}
        {title ? <h3 className="marketplace-list-card__title">{title}</h3> : null}
      </div>
      {headerBadges ? <div className="marketplace-list-card__badges">{headerBadges}</div> : null}
    </div>

    {metaItems.length > 0 ? (
      <div className="marketplace-list-card__meta">
        {metaItems.map((item) => (
          <span key={`${item.icon}-${item.text}`} className={item.className || ""}>
            {item.icon ? <i className={`fa ${item.icon}`}></i> : null}
            {item.text}
          </span>
        ))}
      </div>
    ) : null}

    {note ? <p className="marketplace-list-card__note">{note}</p> : null}

    {items.length > 0 ? (
      <ul className="marketplace-list-card__items">
        {items.map((item) => (
          <li key={`${item.label}-${item.value}`}>
            <span>{item.label}</span>
            <strong>{item.value}</strong>
          </li>
        ))}
      </ul>
    ) : null}

    {children}

    {actions ? <div className="marketplace-list-card__actions">{actions}</div> : null}
  </article>
);

export default MarketplaceListCard;


